import { Component, OnInit, OnChanges, Input, Output, EventEmitter, SimpleChanges, AfterContentChecked, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { ITableHeaders } from '@app/interface/table.interface';
import { TableConstant } from '@app/constant/table.constant';

@Component({
  selector: 'app-search-result-table',
  templateUrl: './search-result-table.component.html',
  styleUrls: ['./search-result-table.component.scss']
})
export class SearchResultTableComponent implements OnInit, OnChanges, AfterContentChecked {

  @ViewChild('stickyHeader') stickeyHeight: ElementRef;
  @ViewChild('scrollContainer') scrollVisibility: ElementRef;
  @ViewChild('popOver') popover: NgbPopover;

  @Input() headerTheme: string = 'default';
  @Input() stickyHeader: boolean = true;
  @Input() isTableBorder: boolean = true;
  @Input() columnHeaders: ITableHeaders[];
  @Input() data: any[];
  @Input() tableAttributes?: any;
  @Input() paginationRequired: boolean = false;
  @Input() isMultiLine: boolean = false;
  @Input() groupView: boolean = false;
  @Input() pageingSize: number;
  @Input() rowCheckbox: string;
  @Input() radioButton: string;
  @Input() checkboxButton: string;
  @Input() selectedCheckbox: any = [];
  @Input() disabledCheckbox: any = [];
  @Input() clearCheckbox: Observable<boolean> = new Observable<null>();
  @Input() removeColor: boolean = false;
  @Input() filteredReset: boolean = false;
  @Output() sortedChanged?= new EventEmitter();
  @Output() pageChanged?= new EventEmitter();
  @Output() navigateTo?= new EventEmitter();
  @Output() ActOnAction?= new EventEmitter();
  @Output() checkedItems?= new EventEmitter();
  @Output() rowActions?= new EventEmitter();
  @Output() rowSeleccted?= new EventEmitter();
  @Output() dialogName?= new EventEmitter();
  @Output() filteredTableCount = new EventEmitter<number>();

  public onHvrTitleDesc = TableConstant.onHoverTitleDesc;
  stickyHeaderHeight: string = '0px';
  sortedColumn: string;
  sortedOrder: string;
  totalCount: number;
  pageVisibleRange: number = 5;
  pageNumberVisibleCount: number;
  pageSize: number;
  pageRange: any = [];
  selectedPage: number = 1;
  startPage: number = 1;
  endPage: number;
  selectedPageIndex: number;
  disableFirst: boolean = false;
  disableLast: boolean = false;
  isShow: Array<boolean> = [];
  expandedRow: number;
  groupedData: string;
  scrollActive: boolean = false;
  sortedData: any = [];
  openDropdown: boolean = false;
  filterValues: any = {};
  baseData: any[];
  selectedFilters: any = {};
  searchKey: string = "";
  tabb: string = "";
  filterActionEvt: any = { isFiltered: false, colName: '' };
  selectedCheckboxs: any = [];
  remainderCheck: boolean = false;
  checkAll: boolean = false;
  filterMaping: any = [];
  disableFilterInputBtn: boolean = true;
  disableFilterDropdownBtn: boolean = true;
  isFilterByText: boolean = false;
  filterCollection: any = [];

  constructor(private router: Router) { }

  ngOnInit() {
    this.sortedColumn = '';
    this.sortedOrder = '';
    this.selectedPageIndex = 1;
    this.disableFirst = true;
    this.sortedData = this.data?.slice();
    this.clearCheckbox.subscribe((data: boolean) => {
      if (data != null && data) { this.checkAll = false; this.selectedCheckboxs = []; }
    });
  }

  public onClickHandler(clickedFilter) {
    this.disableFilterDropdownBtn = false;
    this.selectedFilters[clickedFilter.srcElement.id] = clickedFilter.srcElement.checked;
  }

  public noFilters(): boolean {
    return Object.keys(this.selectedFilters).every((k) => !this.selectedFilters[k]);
  }

  public filterColData2(header) {
    if (header != "") {
      let index = this.filterCollection.findIndex(i => i.header.DataField === header.DataField);
      if (index && index != -1) this.filterCollection.splice(index, 1);
      if (this.filterCollection.find(i => i.header.DataField === header.DataField) === undefined) this.filterCollection.push({ 'name': '', 'header': header });
    }
  }

  public filterColData1(searchKey, header) {
    for (var key in this.filterValues) {
      if (key == header.DataField) {
        header['filterText'] = searchKey;
        header['filterAction'] = true;
      }
      const isCOlFilter = this.filterValues[key].filter(val => { if (val.isChecked) return val; });

      if (isCOlFilter.length > 0) {
        this.data = this.data.filter(colVal => {
          if (this.selectedFilters[colVal[key].Value]) return colVal;
        });
      }
    }
  }

  public filterColData(searchKey, header) {
    if (this.isFilterByText) this.textSearchFilter(searchKey, header);
    if (this.noFilters()) { this.data = this.baseData; }
    else {
      this.data = this.baseData;
      this.filterColData1(searchKey, header);
      if (this.popover.open) this.popover.close();
    }
    this.isFilterByText = false;
    this.filteredTableCount.emit(this.data.length);
    this.filterColData2(header);
  }

  public async resetFilter(column) {
    column['filterAction'] = false;
    column['filterText'] = '';
    this.filterValues[column.DataField].forEach(element => {
      element.isChecked = false;
      this.selectedFilters[element.name] = false;
    });
    this.isFilterByText = false;
    this.searchKey = "";
    this.disableFilterDropdownBtn = true;
    let index = this.filterCollection.findIndex(i => i.header.DataField === column.DataField);
    this.filterCollection.splice(index, 1);
    this.filterColData("", "");
  }

  public async resetFilterAll() {
    this.filterCollection = [];
    this.columnHeaders?.forEach(column => {
      if (column.Label != 'Checkbox') {
        column['filterAction'] = false;
        column['filterText'] = '';
        this.filterValues[column.DataField].forEach(element => {
          element.isChecked = false;
          this.selectedFilters[element.name] = false;
        });
        this.isFilterByText = false;
        this.searchKey = "";
        this.disableFilterDropdownBtn = true;
      }
    });
    this.filterColData("", "");
  }

  public filterResetColData1() {
    for (var key in this.filterValues) {
      const isCOlFilter = this.filterValues[key].filter(val => {
        if (val.isChecked) return val;
      });
      if (isCOlFilter.length) {
        this.data = this.data.filter(colVal => {
          if (this.selectedFilters[colVal[key].Value]) return colVal;
        });
      }
    }
  }

  public filterResetColData() {
    if (this.noFilters()) {
      this.data = this.baseData;
    } else {
      this.data = this.baseData;
      this.filterResetColData1();
    }
  }

  public ngOnChanges2(colVal, each): any {
    let obj = {};
    if (each.DataField === "Cat") {
      obj['name'] = colVal[each.DataField].Value;
      obj['isChecked'] = false;
      obj['desc'] = this.onHvrTitleDesc.Cat[colVal[each.DataField].Value];
    } else if (each.DataField === "Risk" || each.DataField === "Priority") {
      obj['name'] = colVal[each.DataField].Value;
      obj['isChecked'] = false;
      obj['desc'] = this.onHvrTitleDesc[each.DataField][colVal[each.DataField].Value];
    }
    else {
      obj['name'] = colVal[each.DataField].Value;
      obj['isChecked'] = false;
    }
  }

  public ngOnChanges3(colVal, each): any {
    var resArr = [];
    var i = resArr.findIndex(x => x.name == colVal[each.DataField].Value);
    if (i <= -1) {
      resArr.push({ name: colVal[each.DataField].Value });
      return colVal[each.DataField].Value;
    }
  }

  public ngOnChanges1(): void {
    this.columnHeaders?.forEach(each => {
      if (each.hasOwnProperty('filter') && each.filter) {
        this.filterValues[each.DataField] = this.data.filter((colVal, index) => {
          return this.ngOnChanges3(colVal, each);
        }).map(colVal => {
          this.selectedFilters[colVal[each.DataField].Value] = false;
          return this.ngOnChanges2(colVal, each);
        });
      }
    });
  }

  // public ngOnChanges(changes: SimpleChanges): void {
  //   if (this.tableAttributes && this.tableAttributes.TotalCount > 0) {
  //     this.totalCount = this.tableAttributes.TotalCount;
  //     this.pageSize = this.pageingSize ? this.pageingSize : 10;
  //     this.endPage = this.totalCount > this.pageSize ? Math.ceil(this.totalCount / this.pageSize) : 1;
  //     this.pageNumberVisibleCount = this.pageVisibleRange;
  //     this.pageNumberVisibleCount = this.endPage > this.pageNumberVisibleCount ? this.pageNumberVisibleCount : this.endPage;
  //     this.handlePagination(this.tableAttributes.CurrentPage);
  //     this.LoadPageNumbers();
  //   }
  //   this.baseData = this.data;
  //   if (this.data && this.data.length > 0 && this.filterMaping[0]?.name != 'All') { this.filterMaping.push({ 'name': 'All', 'data': this.baseData }); }

  //   this.ngOnChanges1();
  //   if (this.filteredReset) this.resetFilterAll();
  // }

  public ngOnChanges(changes: SimpleChanges): void {
    if (this.tableAttributes && this.tableAttributes.TotalCount > 0) {
      this.totalCount = this.tableAttributes.TotalCount;
      this.pageSize = this.pageingSize ? this.pageingSize : 10;
      this.endPage = this.totalCount > this.pageSize ? Math.ceil(this.totalCount / this.pageSize) : 1;
      this.pageNumberVisibleCount = this.pageVisibleRange;
      this.pageNumberVisibleCount = this.endPage > this.pageNumberVisibleCount ? this.pageNumberVisibleCount : this.endPage;
      this.handlePagination(this.tableAttributes.CurrentPage);
      this.LoadPageNumbers();
    }
    this.baseData = this.data;
    if (this.data && this.data.length > 0 && this.filterMaping[0]?.name != 'All') this.filterMaping.push({ 'name': 'All', 'data': this.baseData });
    this.columnHeaders?.forEach(each => {
      if (each.hasOwnProperty('filter') && each.filter === true) {
        this.filterValues[each.DataField] = this.getFilterValuesByField(each);
      }
    });
    if (this.filteredReset) this.resetFilterAll();
  }

  getFilterValuesByField(field) {
    let resArr = [];
    return this.data.filter((colVal, index) => {
      let i = resArr.findIndex(x => x.name == colVal[field.DataField].Value);
      if (i <= -1) {
        resArr.push({ name: colVal[field.DataField].Value });
        return colVal[field.DataField].Value;
      }
    }).map(colVal => {
      this.selectedFilters[colVal[field.DataField].Value] = false;
      let obj = {};
      if (field.DataField === "Cat") {
        obj['name'] = colVal[field.DataField].Value;
        obj['isChecked'] = false;
        obj['desc'] = this.onHvrTitleDesc.Cat[colVal[field.DataField].Value];
      } else if (field.DataField === "Risk" || field.DataField === "Priority") {
        obj['name'] = colVal[field.DataField].Value;
        obj['isChecked'] = false;
        obj['desc'] = this.onHvrTitleDesc[field.DataField][colVal[field.DataField].Value];
      }
      else {
        obj['name'] = colVal[field.DataField].Value;
        obj['isChecked'] = false;
      }
      return obj;
    });
  }

  public ngAfterContentChecked(): void {
    if (this.stickeyHeight && this.stickyHeader) {
      this.stickyHeaderHeight = '-' + this.stickeyHeight.nativeElement.offsetHeight + 'px';
    }
    if (this.scrollVisibility && this.stickyHeader) {
      this.scrollActive = this.scrollVisibility.nativeElement.offsetHeight < this.scrollVisibility.nativeElement.scrollHeight;
    }
  }

  showScrollTableOverlay() {
    return this.stickyHeader && Number.parseInt(this.stickyHeaderHeight) >= 0;
  }

  public searchDropdown(searchKey, colm) {
    this.filterValues[colm] = this.filterValues[colm].filter(function (item) {
      return item.name.indexOf(searchKey);
    });
  }

  private LoadPageNumbers() {
    if (this.pageNumberVisibleCount === 1) {
      this.pageRange = [];
      this.pageRange.push(1);
      this.disableFirst = true;
      this.disableLast = true;
    }

    if (this.selectedPage === this.pageRange[4]) {
      this.startPage = this.endPage - this.selectedPage < 4 ? this.endPage - 4 : this.selectedPage - 1;

    } else if (this.selectedPage === this.pageRange[0] && this.selectedPage > 3) {
      this.startPage = this.selectedPage - 3;

    } else if (this.selectedPage < 4) {
      this.startPage = 1;
    }

    this.pageRange = [];
    for (let i = this.startPage; i < this.pageNumberVisibleCount + this.startPage; i++) {
      this.pageRange.push(i);
    }
  }

  updatedSortColumn(orderBy, sortOrder) {
    this.sortedOrder = sortOrder === 'ASC' ? 'DESC' : 'ASC';
    this.sortedColumn = orderBy;
    const tableData = this.data.slice();

    if (!this.sortedColumn || this.sortedOrder === '') {
      this.sortedData = tableData;
    } else {
      this.sortedData = tableData.sort((a, b) => {
        const aValue = (a)[this.sortedColumn];
        const bValue = (b)[this.sortedColumn];
        var result1 = (aValue.Value < bValue.Value ? -1 : 1);
        var result2 = (this.sortedOrder === 'ASC' ? 1 : -1);
        var result = result1 * result2;
        return result;
      });
    }
    this.sortedChanged.emit({
      sortColumn: this.sortedColumn,
      sortOrder: this.sortedOrder,
      currentPage: this.selectedPage,
      sortData: this.sortedData
    });
  }

  updatePage(selectedPage: any) {
    this.handlePagination(selectedPage);
    this.pageChanged.emit({
      sortColumn: this.sortedColumn,
      sortOrder: this.sortedOrder,
      currentPage: this.selectedPage
    });
  }

  public getMenuItems(items: any) {
    let res = [];

    for (var item of items) {
      res.push(item);
    }

    return res;
  }
  public btnClick(rowData?: any, faultId?: number, title?: string, link?: string, type?: string, dialogName?: string) {
    if (type === 'openDialog') {
      this.dialogName.emit({ "dialogCondition": dialogName, "data": rowData })
    } else if (link.includes('dialog')) {
      this.dialogName.emit({ data: rowData });
    } else {
      var iindex;
      if (title === 'Add Comment') { iindex = '2'; }
      else if (title === 'View Audit Trail') { iindex = '4'; }
      else { iindex = '0'; }
      localStorage.setItem('tabIndex', iindex);
      const url = this.router.serializeUrl(this.router.createUrlTree([link + faultId]));
      window.open(url);
    }
  }

  private handlePagination(selectedPage: any) {
    if (this.disableFirst || this.disableLast) {
      this.disableFirst = false;
      this.disableLast = false;
    }
    switch (selectedPage) {
      case 'first':
        this.selectedPageIndex = 1;
        this.selectedPage = this.selectedPageIndex;
        this.startPage = 1;
        this.disableFirst = true;
        break;

      case 'previous':
        this.selectedPageIndex = this.selectedPage - 1;
        this.selectedPage = this.selectedPageIndex;
        this.disableFirst = this.selectedPage === 1;
        break;

      case 'next':
        this.selectedPageIndex = this.selectedPage + 1;
        this.selectedPage = this.selectedPageIndex;
        this.disableLast = this.selectedPage === this.endPage;
        break;

      case 'last':
        this.selectedPageIndex = this.endPage;
        this.selectedPage = this.selectedPageIndex;
        if (this.endPage > 4) {
          this.startPage = this.endPage - 4;
        }
        this.disableLast = true;
        break;

      default:
        this.selectedPageIndex = selectedPage;
        this.selectedPage = selectedPage;
        if (this.selectedPage === 1) {
          this.disableFirst = true;
        }
        if (this.selectedPage === this.endPage) {
          this.disableLast = true;
        }
        break;
    }

    if (
      this.pageRange.indexOf(this.selectedPage) === -1 &&
      this.selectedPage >= 1 &&
      this.selectedPage <= this.endPage - 4
    ) {
      this.startPage = this.selectedPage;
    }
  }

  asIsOrder() {
    return 1;
  }

  getTypeOf(value: any) {
    if (value !== undefined && value !== null) {
      return typeof value;
    }
    return null;
  }

  isProperURL(link) {
    return link && String(link).indexOf('http') > -1;
  }

  navigateToLink(evt, url: string, toNewTab = false, cellValue: any = null) {
    evt.preventDefault();
    evt.stopPropagation();
    let origin = window.location.pathname.slice(window.location.pathname.lastIndexOf('/') + 1);

    const domain = `${window.location.origin}`;
    if (this.isProperURL(url)) {
      if (toNewTab) {
        localStorage.setItem('tabIndex', (origin === 'sdashboard' && cellValue?.isPEA !== null || cellValue?.notificationType === 'PEA') ? '5' : '0');
        window.open(url);
      } else {
        url = url.replace(domain, '');
        this.router.navigate([url.split('#')[0].split('?')[0]], {
          queryParams: this.router.parseUrl(url).queryParams,
          fragment: this.router.parseUrl(url).fragment
        });
      }
    } else {
      this.navigateTo.emit(url);
    }
  }

  actOnAction() {
    this.ActOnAction.emit();
  }

  toggleDisplay(id: number) {
    if (id !== undefined) {
      this.expandedRow = id;
      this.isShow[id] = this.isShow[id] === true ? false : true;
    }
  }
  chkBoxValue(chkRow) {
    this.checkedItems.emit(chkRow);
  }

  onCheckboxChange(isChecked, data) {
    this.checkAll = false
    if (isChecked) {
      this.selectedCheckboxs.push(data);
    } else {
      this.selectedCheckboxs.forEach(function (item, index, arr) {
        if (item.recordId == data.recordId) {
          arr.splice(index, 1);
        }
      });
    }
    this.checkedItems.emit(this.selectedCheckboxs);
  }
  onCheckboxAllChange(isChecked) {
    this.selectedCheckboxs = [];
    let allValues = [];
    if (isChecked) {
      this.data.forEach(function (item, index, arr) {
        allValues.push(item)
        item.recordId.isChecked = true;
      });
    } else {
      this.data.forEach(function (item, index, arr) {
        allValues = [];
        item.recordId.isChecked = false;
      });
    }
    this.selectedCheckboxs = allValues;
    this.checkedItems.emit(this.selectedCheckboxs);
  }

  rowActionHandler(actionType, rowData) {
    this.rowActions.emit({ type: actionType, data: rowData });
  }

  selectRadioButton(selectedItem) {
    this.rowSeleccted.emit({ selectedRow: selectedItem });
  }
  popOpen(header) {
    this.sortFilterListInAsc(header);
    this.searchKey = header.filterText ? header.filterText : "";
  }

  filterAction(each, header, bool: boolean, searchTxt) {
    console.log('1', header);
    if (each.DataField == header.DataField) {
      each['filterAction'] = bool;
      each['filterText'] = searchTxt;
    }
  }
  onInputSearchChange(srcText, header) {
    this.isFilterByText = true;
    this.disableFilterInputBtn = srcText ? false : true;
  }
  textSearchFilter(srcText, header) {
    let arr = [];
    let a = this;
    this.filterValues[header.DataField].filter(function (item) {
      let obj = {};
      if (item.name.toLowerCase().includes(srcText.toLowerCase())) {
        obj['name'] = item.name;
        obj['isChecked'] = true;
        a.selectedFilters[item.name] = true
      } else {
        obj['name'] = item.name;
        obj['isChecked'] = false;
      }
      arr.push(obj)
    });
    this.filterValues[header.DataField] = arr
    console.log(this.filterValues)
    console.log(this.selectedFilters)
  }
  resetFilterValues() {
    this.columnHeaders?.forEach(each => {
      if (each.hasOwnProperty('filter') && each.filter) {
        var resArr = [];
        this.filterValues[each.DataField] = this.data.filter((colVal, index) => {
          var i = resArr.findIndex(x => x.name == colVal[each.DataField].Value);
          if (i <= -1) {
            resArr.push({ name: colVal[each.DataField].Value });
            return colVal[each.DataField].Value;
          }
        }).map(colVal => {
          this.selectedFilters[colVal[each.DataField].Value] = false;
          let obj = {};
          if (each.DataField === "Cat") {
            obj['name'] = colVal[each.DataField].Value;
            obj['isChecked'] = false;
            obj['desc'] = this.onHvrTitleDesc.Cat[colVal[each.DataField].Value];
          } else if (each.DataField === "Risk" || each.DataField === "Priority") {
            obj['name'] = colVal[each.DataField].Value;
            obj['isChecked'] = false;
            obj['desc'] = this.onHvrTitleDesc[each.DataField][colVal[each.DataField].Value];
          }
          else {
            obj['name'] = colVal[each.DataField].Value;
            obj['isChecked'] = false;
          }
          return obj;
        });
      }
    });
  }

  sortFilterListInAsc(header) {
    this.filterValues[header.DataField].sort((a, b) => {
      const aValue = (a as any)['name'];
      const bValue = (b as any)['name'];
      return (aValue < bValue ? -1 : 1) * (1);
    });
    let isCheckedArr = [];
    this.filterValues[header.DataField].forEach(element => {
      if (element.isChecked) isCheckedArr.push(element)
    });
    this.disableFilterDropdownBtn = (isCheckedArr.length == 0);
  }
}

